import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBase } from "../base";

export const PaperMaterial = types
  .compose(
    Base,
    types.model({
      code: types.maybeNull(types.string),
      type: types.maybeNull(types.string),
      typeSelect: types.maybeNull(types.string),
      gsm: types.maybeNull(types.number),
      specificationType: types.maybeNull(types.string),
      specificationTypeSelect: types.maybeNull(types.string),
      specificationSize: types.maybeNull(types.number),
      specificationLength: types.maybeNull(types.number),
    })
  )
  .actions(withSetPropAction);
export interface IPaperMaterial extends Instance<typeof PaperMaterial> {}
export interface IPaperMaterialProperties
  extends SnapshotIn<typeof PaperMaterial> {}
export interface IAddPaperMaterial
  extends Omit<IPaperMaterialProperties, keyof IBase> {}
export interface IUpdatePaperMaterial extends IPaperMaterialProperties {}
